import * as FullStory from '@fullstory/browser';
import { shouldIntegrateSessionRecording } from '@modules/common/utils';

export const initializeFullStory = (userID: string) => {
  if (!shouldIntegrateSessionRecording(userID)) {
    return;
  }

  FullStory.init({
    orgId: '1894Q8',
    host: `${process.env.REACT_APP_API_BASE_URL}/fsrelay`,
    script: `${process.env.REACT_APP_API_BASE_URL}/fsrelay/s/fs.js`,
  });
  window['_fs_app_host'] =
    'app.fullstory.com'; /* https://github.com/getsentry/sentry-fullstory/issues/54#issuecomment-1253995185 */
};
